// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patch-notes{width:100%;font-size:1.1rem}`, "",{"version":3,"sources":["webpack://./src/Components/PatchNotes/PatchNotes.style.scss"],"names":[],"mappings":"AAAA,aACE,UAAA,CACA,gBAAA","sourcesContent":[".patch-notes {\n  width: 100%;\n  font-size: 1.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
